import { ChangeEvent, useEffect } from 'react'
import { Badge, HStack, Stack } from '@chakra-ui/react'

import { MaskedInput } from 'components'
import { hourMask } from 'utils/masks'
import CustomFormFieldErrorMessage from 'components/tools/CustomForm/commonComponents/CustomFormFieldErrorMessage'
import { CustomFormViewerQuestionProps } from 'components/tools/CustomForm/types/CustomFormViewerQuestionProps'
import { useCustomFormViewer } from 'components/tools/CustomForm/components/Viewer/contexts/CustomFormViewerManager/Provider'
import validateHourOnCustomForm from 'components/tools/CustomForm/components/Viewer/utils/validateHourOnCustomForm'
import useCustomFormGetDefaultValue from '../../hooks/useCustomFormGetDefaultValue'

export default function CustomFormHourQuestion({
  question,
  questionKey,
  disabled,
  formMethods,
}: CustomFormViewerQuestionProps) {
  const { removeErrorFromQuestion, setErrorOnQuestion, thisQuestionHasError } = useCustomFormViewer()

  const { defaultValue } = useCustomFormGetDefaultValue({ question, questionKey, disabled })

  const questionWithError = thisQuestionHasError(question.slug)?.question

  function setInputErrorMessageOnQuestion(hour: string) {
    const errorMessage = validateHourOnCustomForm({ hour, question })
    if (errorMessage === '') {
      removeErrorFromQuestion(question.slug)
    } else {
      setErrorOnQuestion(question, errorMessage)
    }
  }

  function handleOnBlur(event: ChangeEvent<HTMLInputElement>) {
    const inputValue = event.target.value
    setInputErrorMessageOnQuestion(inputValue)
  }

  useEffect(() => {
    if (defaultValue) {
      setInputErrorMessageOnQuestion(defaultValue)
    }
    if (formMethods?.setValue) {
      formMethods.setValue(questionKey, defaultValue)
    }
  }, [defaultValue])

  return (
    <Stack>
      <MaskedInput
        id={question.slug}
        isDisabled={disabled}
        mask={hourMask}
        placeholder={question?.placeholder}
        value={formMethods?.watch ? formMethods.watch(questionKey) : defaultValue}
        {...(formMethods?.register && formMethods.register(questionKey, { onBlur: handleOnBlur }))}
      />

      <CustomFormFieldErrorMessage message={questionWithError?.error_message} />

      {question.validation && (
        <HStack>
          {question.validation.min && <Badge textTransform="none">Horário mínimo ({question.validation.min})</Badge>}
          {question.validation.max && <Badge textTransform="none">Horário máximo ({question.validation.max})</Badge>}
        </HStack>
      )}
    </Stack>
  )
}
